import * as Constants from './Constants';

const initialState = {
  title: 'Tagging',
  readDlPlans: false,
  taggingApiFlag: false,
  eventQueue: [],
};

function Tagging(state = initialState, action) {
  switch (action.type) {
    case Constants.TAGGING_SUCCESS:
      return { ...state, channelSession: action.response };
    case Constants.READDL_SUCCESS:
      return { ...state, readDlPlans: action.response };
    case 'TAGGING_FLAG':
      return { ...state, taggingApiFlag: action.data };
    case Constants.ADD_ADOBE_EVENT:
      return { ...state, eventQueue: [...state.eventQueue, action.eventData] };
    case Constants.CLEAR_ADOBE_QUEUE:
      return { ...state, eventQueue: [] };
    default:
      return state;
  }
}

export default Tagging;
